import Vue from "vue";
import App from "./App";
import router from "./router/index";

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import "./main.css";
import "./ckeditor.css";
import CKEditor from "@ckeditor/ckeditor5-vue2";

Vue.use(PaperDashboard);
Vue.use(CKEditor);

/* eslint-disable no-new */
new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");